import { gql } from "apollo-server-lambda";

export const query = gql`
query allproducts {
  products {
    id
    name
    description
    imageURL
    brand
    status
    category
    price
    discount
    stock
    option{
      title
      type
      values{
        name
        price
        stock
        image
      }
    }
    createdAt
    manufacturer
    mfalink
    modelname
  }
}
`;
